module.exports = __webpack_public_path__ + "images/emoji/tongue.d59c162b9b36054da267.png";